import { createAction, props, union } from '@ngrx/store';
import { Company, DeleteCompanyDataEntry } from 'app/api/company.api.service';

const source = 'company';
const actions = 'api';

export const companyRequested = createAction(`[${source}][${actions}] Company requested`, props<{ companyId: string }>());
export const companyLoaded = createAction(`[${source}][${actions}] Company loaded`, props<{ company: Company }>());
export const companyCancelled = createAction(`[${source}][${actions}] Company cancelled`, props<{ errorMessage: string }>());

// tslint:disable-next-line: max-line-length
// export const companyDeleteRequested = createAction(`[${source}][${actions}] Company delete requested`, props<{ input: DeleteCompanyDataEntry }>());
// tslint:disable-next-line: max-line-length
// export const companyDeleteError = createAction(`[${source}][${actions}] Company delete error`, props<{ errorMessage: string }>());
// tslint:disable-next-line: max-line-length
// export const companyDeleteSuccess = createAction(`[${source}][${actions}] Company delete success`, props<{ entry: DeleteCompanyDataEntry }>());

const all = union({
  companyRequested,
  companyLoaded,
  companyCancelled,
  // companyDeleteRequested,
  // companyDeleteError,
  // companyDeleteSuccess
});

export type CompanyActionsUnion = typeof all;
